import { InsertLink } from './insert-link.js';
import { RemoveLink } from './remove-link.js';


export function Link (pEditor)
{
  this.inserter = new InsertLink(pEditor, this);
  this.remover = new RemoveLink(pEditor, this);
  
  
  this.openLinkDropdown = (pButton) =>
  {
    pEditor.pDropdown = pButton.getDropdown();

    if (!pEditor.pDropdown)
    {
      return false;
    }

    if (pEditor.pDropdown.getState())
    {
      pEditor.closeDropdown(pButton);
    }
    else
    {
      pEditor.pDropdown.setReturnedParameters('selectedStyleId', '');
      pEditor.pDropdown.setReturnedParameters('openInsertLinkDialog_disabled', !(this.inserter.queryOpenInsertLinkDialogEnabled(pButton, 'openInsertLinkDialog') && !pEditor.anchor.isAnchorSelected()));
      pEditor.pDropdown.setReturnedParameters('openInsertLinkDialog_current', this.remover.queryRemoveLinkEnabled(pButton));
      pEditor.pDropdown.setReturnedParameters('openInsertAnchorDialog_disabled', !pEditor.anchor.inserter.queryOpenInsertAnchorDialogEnabled(pButton, 'openInsertAnchorDialog'));
      pEditor.pDropdown.setReturnedParameters('openInsertAnchorDialog_current', pEditor.anchor.isAnchorSelected());
      pEditor.pDropdown.setReturnedParameters('openInsertLinkToAnchorDialog_disabled', !(pEditor.anchor.link.queryOpenInsertLinkToAnchorDialogEnabled(pButton, 'openInsertLinkToAnchorDialog') && !pEditor.anchor.isAnchorSelected()));
      pEditor.pDropdown.setReturnedParameters('openInsertLinkToAnchorDialog_current', this.remover.queryRemoveLinkEnabled(pButton));
      pEditor.pDropdown.setReturnedParameters('insertTableOfContent_disabled', !(pEditor.anchor.toc.queryInsertTableOfContent(pButton, 'insertTableOfContent') && !pEditor.anchor.isAnchorSelected()));
      pEditor.pDropdown.setReturnedParameters('setAnchorsVisibility_current', pEditor.anchor.queryStateAnchors(pButton, 'setAnchorsVisibility'));
      pEditor.openDropdown(pButton, pEditor.pDropdown, 'linkDropdownHandler');
    }
  };


  this.linkDropdownHandler = (pButton, command) =>
  {
    var pParameters, tCommand;

    pEditor.pDropdown = pButton.getDropdown();

    if (pEditor.pDropdown)
    {
      pParameters = pEditor.pDropdown.getReturnedParameters();

      if (pParameters && pParameters.selectedStyleId)
      {
        tCommand = pParameters.selectedStyleId;
      }
    }

    pEditor.closeDropdown(pButton);

    if (tCommand)
    {
      pEditor.pThis.execCommand(pButton, tCommand);
    }
  };
}